<template>
    <div class="main-content__wizzard">
        <div class="wizzard__content">
            <h2 class="wizzard__step-title" v-translate>
                Review and Set reminders
            </h2>
            <h3 v-translate>Set default reminders for all below activities</h3>
            <div class="wizzard__notifications">
                <reminder-form v-for="(reminder, i) in objective.reminders" v-model="reminder.reminder_data"
                               @delete="removeReminder(i)" :key="'reminder'+i" />
                <div class="wizzard__add-new-notification">
                    <button @click="addReminder()" class="button button--gray button--small" v-translate>Add reminder</button>
                </div>
            </div>
            <h3 v-translate>Review your steps</h3>
            <ul class="wizzard__steps-to-objective wizzard__steps-to-objective--review">
                <activity-review v-for="activity in sortedActivities" :activity="activity" :key="activity.name" :color="objective.color"/>
                <li class="steps-to-objective__finish">
                    <div class="steps-to-objective__activity-title" v-translate>Objective completed</div>
                </li>
            </ul>

            <div class="form__action-buttons">
                <a href="javascript:;" class="button button--primary" @click="$emit('add')" v-translate>Add objective/goal</a>
                <a href="javascript:;" class="button button--transparent" @click="$emit('advance','step-3')" v-translate>Previous step</a>
            </div>
        </div>
        <div class="wizzard__tips">
            <h2 v-translate>Quick tips</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid aperiam eligendi eos facilis
                illo, ipsa iste, laboriosam laudantium porro qui similique, sit suscipit tempore vero voluptate.
                Eaque impedit porro quae.</p>
            <p>Ab adipisci deserunt eius expedita explicabo, facilis, in mollitia natus provident quam quisquam,
                quo reiciendis repudiandae temporibus vel velit voluptate. Adipisci ducimus eligendi itaque,
                nesciunt pariatur perferendis rerum totam voluptates.</p>
            <p>Assumenda consequatur eaque est expedita hic labore maiores, molestias odio perferendis repellat
                soluta tempore voluptatem. Facilis in inventore itaque neque repellat unde ut. A animi
                architecto consequatur consequuntur quibusdam, quos.</p>
        </div>
    </div>
</template>
<script>
    import ReminderForm from "./ReminderForm";
    import ActivityReview from "./ActivityReview";
    import ActivityClass from "../mixins/ActivityClass";

    export default {
        name: 'plan-objective-step-four',
        mixins: [ActivityClass],
        components: {ActivityReview, ReminderForm},
        data() {
            return {
                objective: {},
            }
        },
        props: {
            parent_objective: {},
        },
        beforeMount: function () {
            this.objective = this.parent_objective
        },
        methods: {
            addReminder: function () {
                this.objective.reminders.push({
                    reminder_data: {
                        via: 'email',
                        when: 1,
                        what: 'days'
                    }
                })
            },
            removeReminder: function (i) {
                this.objective.reminders.splice(i, 1)
            }
        }
    }
</script>